<template>
  <div id="afdc-widget-footer" class="afdc-clearfix">
    <div id="afdc-widget-source">
      <template v-if="$store.getters.localeCountry === 'CA'">
        {{ $t('Source:') }} <a v-bind:href="$store.getters.localeLang === 'fr' ? 'https://ressources-naturelles.canada.ca/efficacite-energetique/efficacite-energetique-transports-carburants-remplacement/localisateur-stations-recharge-stations-ravitaillement-carburants-remplacement/20488' : 'https://natural-resources.canada.ca/energy-efficiency/transportation-alternative-fuels/electric-charging-alternative-fuelling-stationslocator-map/20487'" target="_parent">{{ $t('Natural Resources Canada') }}</a>
      </template>

      <template v-else>
        Source: <a href="https://afdc.energy.gov" target="_parent">Alternative Fuels Data Center</a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
#widget-footer {
  background-color: #444;
  line-height: 30px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: normal;
  color: #fff;
  border-top: 1px solid #aaa;
  text-shadow: none;

  #widget-source {
    float: right;
    a, a:hover, a:active, a:visited {
      color: #fff;
      text-decoration: underline;
    }
  }
}
</style>
